import { NgModule } from '@angular/core';
import { TelHrefPipe } from './tel-href.pipe';

@NgModule({
    declarations: [TelHrefPipe],
    exports: [TelHrefPipe],
})
export class FiTelHrefModule {}
